export default __webpack_public_path__ + "static/hero-ae4564804c5cf133b6d312f9c33efc98.jpg";